// extracted by mini-css-extract-plugin
export default {"addToCartControl":"PY-z","giftCard":"QY-z","btnContainer":"RY-z","cartButton":"SY-z","disabled":"TY-z"};